<ng-container [formGroup]="form">
  <ix-input
    formControlName="host"
    [label]="'Host' | translate"
    [required]="true"
    [tooltip]="helptext.InfluxDB_host_tooltip | translate"
  ></ix-input>

  <ix-input
    formControlName="username"
    [label]="'Username' | translate"
    [required]="true"
    [tooltip]="helptext.InfluxDB_username_tooltip | translate"
  ></ix-input>

  <ix-input
    formControlName="password"
    type="password"
    [label]="'Password' | translate"
    [required]="true"
    [tooltip]="helptext.InfluxDB_password_tooltip | translate"
  ></ix-input>

  <ix-input
    formControlName="database"
    [label]="'Database' | translate"
    [required]="true"
    [tooltip]="helptext.InfluxDB_database_tooltip | translate"
  ></ix-input>

  <ix-input
    formControlName="series_name"
    [label]="'Series' | translate"
    [required]="true"
    [tooltip]="helptext.InfluxDB_series_name_tooltip | translate"
  ></ix-input>
</ng-container>
